import { useLang } from "@/lang";

export default function Marquee() {
  const { t } = useLang();
  return (
    <div
      data-testid="marquee-band"
      className="marquee relative overflow-hidden border-y border-navy/10 bg-gold py-4"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex items-center">
            {t.marquee.map((m) => (
              <span key={m} className="flex items-center">
                <span className="whitespace-nowrap px-6 text-[13px] font-semibold uppercase tracking-[0.3em] text-navy sm:px-10">
                  {m}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-navy/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
